import { render } from "./ButtonNotification.vue?vue&type=template&id=affe0a4c&scoped=true"
import script from "./ButtonNotification.vue?vue&type=script&lang=js"
export * from "./ButtonNotification.vue?vue&type=script&lang=js"

import "./ButtonNotification.vue?vue&type=style&index=0&id=affe0a4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-affe0a4c"]])

export default __exports__